import { useTranslation } from 'react-i18next';

import { Modal } from 'components/ui';
import { type AtlasGqlDamage, type AtlasGqlHorizonDamage } from 'types/atlas-graphql';

import { CreateTasksFromDamagesForm } from '../CreateTasksFromDamagesForm';

export const CREATE_TASKS_DAMAGE_LIMITS = { min: 1, max: 200 };

interface ICreateTasksFromDamagesModal {
  damages: (AtlasGqlHorizonDamage | AtlasGqlDamage)[];
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const CreateTasksFromDamagesModal: React.FC<ICreateTasksFromDamagesModal> = ({
  damages,
  open,
  setOpen,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('assets.createTasks', 'Create Tasks')}
      visible={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <CreateTasksFromDamagesForm damages={damages} open={open} setOpen={setOpen} />
    </Modal>
  );
};
